import {
  FrameworkListView,
  FrameworkNewView,
  FrameworkEditView,
} from '@/views/authenticated/frameworks';

export default [
  {
    path: '/frameworks',
    name: 'app_framework_list',
    meta: { title: 'Frameworks', redirectAuthenticatedUsers: false, requiresAdmin: true },
    component: FrameworkListView,
  },
  {
    path: '/frameworks/new',
    name: 'app_framework_new',
    meta: { title: 'Add a Framework', redirectAuthenticatedUsers: false, requiresAdmin: true },
    component: FrameworkNewView,
  },
  {
    path: '/frameworks/:framework/edit',
    name: 'app_framework_edit',
    meta: { title: 'Edit a Framework', redirectAuthenticatedUsers: false, requiresAdmin: true },
    component: FrameworkEditView,
  },
];
